export interface TutorialSummary {
  id: string;
  slug: string;
  category: string;
  menuOption: string | null;
  title: string;
  description: string;
  audience: string[];
  language: string;
  durationSeconds: number | null;
  version: string;
  status: 'draft' | 'published';
  updatedAt: string;
  keywords: string[];
  playable: boolean;
  hasThumbnail: boolean;
}

export interface TutorialDetail extends TutorialSummary {
  steps: Array<{ n: number; title: string; body: string }>;
  chapters: Array<{ t: number; title: string }>;
  transcript: string | null;
  verifiedAppRevision?: string | null;
  related: TutorialSummary[];
  media: { video: string; captions: string; thumbnail: string | null } | null;
}

export interface HelpCategory { id: string; title: string; order: number; count: number }

export const ROLE_LABEL: Record<string, string> = {
  super_user: 'Super users', administrator: 'Administrators', manager: 'Managers', supervisor: 'Supervisors', team_lead: 'Team leads', hr: 'HR', agent: 'Agents',
};

export const audienceText = (audience: string[]): string => (audience.length ? audience.map((r) => ROLE_LABEL[r] || r).join(', ') : 'Everyone');

export function durationText(seconds: number | null): string {
  if (!seconds || seconds <= 0) return '';
  const m = Math.floor(seconds / 60);
  const s = Math.round(seconds % 60);
  return m ? `${m} min${s ? ` ${s} s` : ''}` : `${s} s`;
}

export const clock = (seconds: number): string => `${Math.floor(seconds / 60)}:${String(Math.floor(seconds % 60)).padStart(2, '0')}`;
